import { useContext } from 'react'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import {
  Product,
  createProduct as apiCreateProduct,
  updateProduct as apiUpdateProduct
} from '../../../../../services/product'
import { pages } from '../../../../../config/pages'

import { ProductFormContext } from '../context'

export function useProduct() {
  const { product, loading, setLoading, getProductState, updateProductState } =
    useContext(ProductFormContext)
  const navigate = useNavigate()

  function createProduct(data: Partial<Product>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => apiCreateProduct(data))
      .then(data => updateProductState(data))
      .then(() => {
        toast.info('Produto cadastrado com sucesso')
        navigate(pages.products.path)
      })
      .finally(() => setLoading(false))
  }

  function updateProduct(data: Partial<Product>) {
    Promise.resolve()
      .then(() => setLoading(true))
      .then(() => getProductState())
      .then(order => apiUpdateProduct(order.id, data))
      .then(data => updateProductState(data))
      .then(() => {
        toast.info('O produto foi alterado')
        navigate(pages.products.path)
      })
      .finally(() => setLoading(false))
  }

  return {
    product,
    loading,
    createProduct,
    updateProduct
  }
}
